import React from 'react';
import { UsersIcon, TargetIcon, HeartIcon, AwardIcon } from 'lucide-react';
export function AboutPage() {
  const values = [{
    icon: UsersIcon,
    title: 'Community First',
    description: 'We believe in the power of community. Our platform connects local creatives with buyers who appreciate authentic, handcrafted work.'
  }, {
    icon: TargetIcon,
    title: 'Quality Focus',
    description: 'Every listing on our platform is curated to ensure quality. We support creatives who take pride in their craft.'
  }, {
    icon: HeartIcon,
    title: 'Passion Driven',
    description: 'We are passionate about supporting local talent and helping creative entrepreneurs thrive in Nakuru and beyond.'
  }, {
    icon: AwardIcon,
    title: 'Excellence',
    description: 'We strive for excellence in everything we do, from user experience to customer support.'
  }];
  const team = [{
    name: 'John Kamau',
    role: 'Founder & CEO',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop'
  }, {
    name: 'Mary Wanjiku',
    role: 'Head of Operations',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop'
  }, {
    name: 'Peter Ochieng',
    role: 'Lead Developer',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop'
  }, {
    name: 'Grace Akinyi',
    role: 'Community Manager',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop'
  }];
  return <main className="min-h-screen bg-gray-50" data-id="element-238">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20 px-4" data-id="element-239">
        <div className="max-w-4xl mx-auto text-center" data-id="element-240">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-241">
            About Zinga Creatives
          </h1>
          <p className="text-xl text-blue-100" data-id="element-242">
            Empowering Nakuru's creative community since 2020
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-243">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-244">
          <div data-id="element-245">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-246">Our Story</h2>
            <div className="space-y-4 text-gray-600" data-id="element-247">
              <p data-id="element-248">
                Zinga Creatives was born from a simple observation: Nakuru is
                home to incredibly talented artists, craftspeople, and service
                providers, but they often struggle to connect with potential
                buyers.
              </p>
              <p data-id="element-249">
                Founded in 2020, our platform bridges this gap by providing a
                dedicated marketplace where local creatives can showcase their
                work, services, and events to an engaged community of buyers.
              </p>
              <p data-id="element-250">
                Today, we're proud to have helped hundreds of creatives grow
                their businesses and connect with thousands of satisfied
                customers across Kenya.
              </p>
            </div>
          </div>
          <div className="relative" data-id="element-251">
            <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=400&fit=crop" alt="Team collaboration" className="rounded-xl shadow-lg" data-id="element-252" />
            <div className="absolute -bottom-6 -left-6 bg-orange-500 text-white p-6 rounded-xl shadow-lg" data-id="element-253">
              <p className="text-3xl font-bold" data-id="element-254">500+</p>
              <p className="text-sm" data-id="element-255">Active Creatives</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-256">
        <div className="max-w-7xl mx-auto" data-id="element-257">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12" data-id="element-258">
            Our Values
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-259">
            {values.map((value, index) => <div key={index} className="text-center" data-id="element-260">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 text-blue-600 rounded-full mb-4" data-id="element-261">
                  <value.icon className="w-8 h-8" data-id="element-262" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-263">
                  {value.title}
                </h3>
                <p className="text-gray-600" data-id="element-264">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-265">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-12" data-id="element-266">
          Meet Our Team
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-267">
          {team.map((member, index) => <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden text-center" data-id="element-268">
              <img src={member.image} alt={member.name} className="w-full h-48 object-cover" data-id="element-269" />
              <div className="p-4" data-id="element-270">
                <h3 className="font-semibold text-gray-900" data-id="element-271">{member.name}</h3>
                <p className="text-sm text-gray-500" data-id="element-272">{member.role}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 px-4 bg-blue-900 text-white" data-id="element-273">
        <div className="max-w-7xl mx-auto" data-id="element-274">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-275">
            <div data-id="element-276">
              <p className="text-4xl font-bold mb-2" data-id="element-277">500+</p>
              <p className="text-blue-200" data-id="element-278">Active Creatives</p>
            </div>
            <div data-id="element-279">
              <p className="text-4xl font-bold mb-2" data-id="element-280">10,000+</p>
              <p className="text-blue-200" data-id="element-281">Happy Customers</p>
            </div>
            <div data-id="element-282">
              <p className="text-4xl font-bold mb-2" data-id="element-283">2,500+</p>
              <p className="text-blue-200" data-id="element-284">Listings</p>
            </div>
            <div data-id="element-285">
              <p className="text-4xl font-bold mb-2" data-id="element-286">50+</p>
              <p className="text-blue-200" data-id="element-287">Events Hosted</p>
            </div>
          </div>
        </div>
      </section>
    </main>;
}